(() => {
  if (window.GangavaProductActionsReady) return;
  window.GangavaProductActionsReady = true;
  const showStatus = (button, message, persist) => {
    const status = button.parentElement.querySelector('[data-gangava-share-status]');
    if (!status) return;
    status.hidden = false;
    status.textContent = message;
    if (!persist) window.setTimeout(() => { status.hidden = true; }, 2400);
  };
  const copyUrl = (button, url) => {
    const copied = () => showStatus(button, 'Enlace copiado', false);
    const fallback = () => showStatus(button, 'Copia el enlace del producto: ' + url, true);
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(copied).catch(fallback);
      return;
    }
    try {
      const textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      const copiedByCommand = document.execCommand('copy');
      textarea.remove();
      copiedByCommand ? copied() : fallback();
    } catch (error) {
      fallback();
    }
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gangava-share]');
    if (!button) return;
    event.preventDefault();
    const url = button.dataset.shareUrl;
    if (!url) return;
    const title = button.dataset.shareTitle || '';
    const text = button.dataset.shareText || title;
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobile && navigator.share) {
      navigator.share({ title, text, url }).catch(() => {});
      return;
    }
    copyUrl(button, url);
  });
})();
